import { render, staticRenderFns } from "./ss-breadcrumb.vue?vue&type=template&id=149de8ba&scoped=true&"
import script from "./ss-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./ss-breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./ss-breadcrumb.vue?vue&type=style&index=0&id=149de8ba&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149de8ba",
  null
  
)

export default component.exports